
const mutations = {
  setCvs(state, data) {
    state.cvs = data || [];
  },
  setCvsTotalCount (state, data) {
    state.cvsTotalCount = data
  },
  setOnlineCvData(state, data) {
    state.onlineCvData = data
  },
  setCvActiveIndex(state, data) {
    state.cvActiveIndex = data
  }
}

export default mutations
